rdefine('app/components/SelectPicker',['backbone'],function(Backbone) {

    var SelectOptionView = Backbone.Ribs.View.extend({
        tagName:'option',
        bindings:{
            el:{
                attr:{
                    value:'model.id',
                    selected:{
                        data:['model.id','amodel.curval'],
                        processor:function(a,b) {
                            return (a==b)?"selected":false;
                        }
                    }
                },
                text:'model.value'
            }
        },
        initialize(opts) {
            this.amodel = opts.amodel;
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'select',
        field: null,
        bindings:{
            'el':{
                collection:{
                    col:'col',
                    view: function(opts) {
                        opts.amodel = opts.collection.amodel;
                        return new SelectOptionView(opts); }
                }
            }
        },
        amodel:null,
        col:null,
        initialize:function(options) {
            this.col = new Backbone.Ribs.Collection(options.collection.models, {model: Backbone.Ribs.Model});
            this.collection.on("add reset remove", function(){
                this.col.reset(this.collection.models);
            }.bind(this));
            this.amodel = new Backbone.Ribs.Model({curval:null});
            this.col.amodel = this.amodel;
            this.field = options.field;

            this.amodel.set('curval', this.model.get(this.field));
            this.model.on('change:'+this.field, function() {
                this.amodel.set('curval', this.model.get(this.field));
                this.collection.reset(this.collection.models);
                this.$el.selectpicker('refresh');
            }.bind(this));
            this.bindings.el.value = {
                data:'model.'+this.field,
                events:'change'
            };
        }
    });
});